import { mapPath } from '../api';

/**
 * The map the person had open on the goals tab, kept for this browser tab (session storage): the tab of the Tasks page leads
 * back to it, so a look at a task between two visits to the goals does not lose the place. The map's "To the list" button
 * (and a map that is gone) forgets it, and the tab leads to the list again.
 */
const KEY = 'orbita.goals.lastMap';

export function lastOpenedMap(): string | null {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function rememberMap(mapId: string): void {
  try {
    sessionStorage.setItem(KEY, mapId);
  } catch {
    // The map is not remembered when the browser keeps no storage; the tab leads to the list.
  }
}

export function forgetMap(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing was kept.
  }
}

/** Where the goals tab leads while it is not open: the map left open last, else the list (`undefined`: the default address). */
export function useGoalsTabTarget(): string | undefined {
  const mapId = lastOpenedMap();
  return mapId ? mapPath(mapId) : undefined;
}
